<script>
  import Link from '../../utils/link.html';
  import Menu from '../../components/navigation/step';
  import Archive from '../../components/buttons/trash';
  import Plus from '../../components/buttons/plus';
  import Loader from '../../components/ui/loader.html';
  import { onMount, afterUpdate, getContext } from 'svelte';
  import { gql } from 'apollo-boost';

  import { PROGRAM } from '../../graphql/programs';

  import EventGeneral from './components/forms/event.general';
  import EventStatus from './components/forms/event.status';
  import EventCommunications from './components/forms/event.communications';
  import EventProgram from './components/forms/event.program';
  import EventReview from './components/forms/event.review';
  import { addNotification, ICONS } from '../../utils/notifications.store';
  import { ADD_EVENT } from '../../graphql/events';

  const client = getContext('apollo');

  export let match = {};
  let loading = true;
  let event = {
    name: '',
    notes: '',
    startTime: null,
    endTime: null,
    leader: { id: '' },
    program: { id: match.params.program || '' },
    communications: [
      { type: 'Tips', useParent: true },
      { type: 'Reminder', useParent: true },
      { type: 'ThankYou', useParent: true }
    ],
    constraintCapacityGroup: 0
  };

  let error;
  let current = EventGeneral;
  let active = match.params.section || 'general';

  function selectStep(id, component) {
    current = component;
    active = id;
  }

  async function getProgram(id) {
    addNotification({ message: 'Loading Program Data', icon: ICONS.LOADING });
    try {
      const { data } = await client.query({
        query: PROGRAM,
        variables: { id: id }
      });

      // guards
      if (!data.program.category) {
        data.program.category = {};
      }

      if (!data.program.secondaryCategory) {
        data.program.secondaryCategory = {};
      }

      addNotification({
        message: 'Loaded Program Data',
        icon: ICONS.SUCCESS,
        time: 2000
      });

      if (!event.constraintCapacityTotal) {
        event.constraintCapacityTotal = data.program.constraints.capacity;
      }

      if (!event.constraintStaff) {
        event.constraintStaff = data.program.constraints.staff;
      }

      event.communications = data.program.communications.map(communication => {
        return {
          type: communication.type,
          subject: communication.subject,
          body: communication.body,
          useParent: true
        };
      });

      event.program = data.program;
    } catch (e) {
      addNotification({
        message: 'There was an error loading Program Data',
        icon: ICONS.ERROR,
        time: 3000
      });
      error = e;
    }
  }

  $: menu = [
    {
      id: 'general',
      label: 'General',
      click: () => selectStep('general', EventGeneral)
    },
    {
      id: 'status',
      label: 'Status',
      disabled: !event.program.id,
      click: () => selectStep('status', EventStatus)
    },
    {
      id: 'communications',
      label: 'Communications',
      disabled: !event.program.id,
      click: () => selectStep('communications', EventCommunications)
    },
    {
      id: 'program',
      label: 'Program',
      disabled: !event.program.id,
      click: () => selectStep('program', EventProgram)
    },
    {
      id: 'review',
      label: 'Review & Publish',
      disabled: !event.program.id,
      click: () => selectStep('review', EventReview)
    }
  ];

  onMount(() => {
    if (match.params.program) {
      getProgram(match.params.program);
    }
  });
</script>

<div class="grid-x grid-margin-x">
  <div class="cell small-12 medium-6">
    <h1>Add Event</h1>
  </div>
  <div class="cell small-12 medium-6 text-right">
    <!-- right -->
  </div>
</div>
<div class="grid-x grid-margin-x">
  <div class="cell small-12 medium-12">
    <Menu active="{active}" items="{menu}"></Menu>
  </div>
</div>

<svelte:component this="{current}" bind:value="{event}" />
